__turbopack_context__.v({
  "eyebrow": "AiChatBotServicesCardSection-module__VXe-EW__eyebrow",
  "grid": "AiChatBotServicesCardSection-module__VXe-EW__grid",
  "section": "AiChatBotServicesCardSection-module__VXe-EW__section",
  "title": "AiChatBotServicesCardSection-module__VXe-EW__title",
});
